import { linkToPatient } from "$routes/patient/links";
import { stringify } from "qs";

const appendSearch = (params: Record<string, string>) => {
  return stringify(params, { addQueryPrefix: true });
};

export function linkToNewConsultation(opts: { patientUuid?: string } = {}) {
  const search = {
    patientUuid: opts.patientUuid,
  };

  return `${linkToPatient()}/consultations/new${appendSearch(search)}`;
}

export function linkToNewConsultationReview(
  opts: { patientUuid?: string } = {},
) {
  const search = {
    patientUuid: opts.patientUuid,
  };

  return `${linkToNewConsultation()}/review${appendSearch(search)}`;
}
